<template>
  <div>
    <el-form :inline="true" :model="form">
      <el-form-item label="物料名称/ID">
        <el-input v-model="form.materialData"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" @click="handleSearch">
          <i class="el-icon el-icon-search" />查询
        </el-button>
        <el-button size="small" @click="resetForm">
          <i class="el-icon el-icon-refresh-right" />重置
        </el-button>
      </el-form-item>
    </el-form>
    <Table ref="table" :props="table.props" :header="table.header" :data="table.data" />
    <pagination
      :currentpage="pager.currentPage"
      :pagesize="pager.pageSize"
      :totalcount="pager.totalCount"
      @handle-size-change="handleSizeChange"
      @handle-current-change="handleCurrentChange"
    ></pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        materialData: ''
      },
      table: {
        props: {
          border: true,
          'tooltip-effect': 'dark',
          'row-style': { height: '40px' },
          'cell-style': { padding: '0' },
          'max-height': 400
        },
        header: [
          {
            label: '缩略图',
            align: 'left',
            prop: 'materialIcon',
            width: 100,
            render: (h, { row }) => {
              return (
                <div style="user-select: none;margin-top:10px">
                  <el-image src={row.materialIcon} lazy={true} style="width:80px;height:50px" />
                </div>
              )
            }
          },
          {
            label: '物料ID',
            align: 'left',
            prop: 'materialId',
            width: 100,
            'show-overflow-tooltip': true
          },
          {
            label: '物料名称',
            align: 'left',
            prop: 'materialName',
            'min-width': 150,
            'show-overflow-tooltip': true
          },
          {
            label: '广告位',
            align: 'left',
            prop: 'adSpaceName',
            'min-width': 150,
            'show-overflow-tooltip': true
          },
          {
            label: '描述',
            align: 'left',
            prop: 'description',
            'min-width': 150,
            'show-overflow-tooltip': true
          },
          {
            label: '操作',
            align: 'left',
            width: 100,
            fixed: 'right',
            render: (h, { row }) => {
              return h('div', [
                h(
                  'el-button',
                  {
                    props: {
                      type: 'text'
                    },
                    class: 'el-table-button-text',
                    on: {
                      click: (event) => {
                        event.stopPropagation()
                        this.submitSelect(row)
                      }
                    }
                  },
                  '选择'
                )
              ])
            }
          }
        ],
        data: []
      },
      pager: {
        currentPage: 1,
        pageSize: 10,
        totalCount: 0
      }
    }
  },
  methods: {
    init() {
      this.handleSearch()
    },
    handleSearch() {
      this.pager.pageSize = 10
      this.fetchData()
    },
    fetchData() {
      this.loading = true
      const [pageSize, pageNo] = [this.pager.pageSize, this.pager.currentPage]
      const filter = { pageSize, pageNo, ...this.form }
      this.$service
        .getMaterialPackageList(filter)
        .then((data) => {
          this.loading = false
          this.table.data = data.rows || []
          this.pager.totalCount = data.total || 0
        })
        .catch(() => {
          this.loading = false
        })
    },
    handleSizeChange(val) {
      this.pager.pageSize = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.pager.currentPage = val
      this.fetchData()
    },
    resetForm() {
      this.form.materialData = ''
    },
    submitSelect(row) {
      this.$emit('select-data', row)
    }
  }
}
</script>

<style lang="stylus" scoped>
.el-icon
  padding-right 5px
.el-table
  border-right 1px solid #EBEEF5
  >>>th, .el-table >>>tr
    height 33px
</style>
